// extracted by mini-css-extract-plugin
export var letsTalk = "letsTalk-module--letsTalk--f83c3";
export var letsTalk__closeButton = "letsTalk-module--letsTalk__closeButton--d9f29";
export var letsTalk__container = "letsTalk-module--letsTalk__container--5fb08";
export var letsTalk__email = "letsTalk-module--letsTalk__email--a0679";
export var letsTalk__heading = "letsTalk-module--letsTalk__heading--2d9fd";
export var letsTalk__headingSection = "letsTalk-module--letsTalk__headingSection--d6ffd";
export var letsTalk__link = "letsTalk-module--letsTalk__link--299eb";
export var letsTalk__reviews = "letsTalk-module--letsTalk__reviews--72e6b";
export var letsTalk__user = "letsTalk-module--letsTalk__user--14ea9";